import * as Yup from "yup";

export const performanceNoteSchema = Yup.object().shape({
  date: Yup.string().required("Date is required"),
  noteType: Yup.string().required("Note type is required"),
  title: Yup.string().required("Title is required"),
  details: Yup.string().required("Details are required"),
});
